// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Ajce Hostel App React example components
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/studentsList/data/useStudentsListData";
import { useMaterialUIController } from "context";

export function StudentListTable({ enableToolbar }) {
  const { columns, rows } = authorsTableData();
  const [MUIController] = useMaterialUIController();

  return (
    <MDBox pt={!enableToolbar ? 6 : 0} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            {!enableToolbar ? (
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={MUIController.sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Students List
                </MDTypography>
              </MDBox>
            ) : (
              ""
            )}
            <MDBox pt={3}>
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                entriesPerPage={true}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}
